import styled from 'styled-components';

const HeaderWrapper = styled.div`
.p-dropdown:not(.p-disabled).p-focus{
    box-shadow: none;
}
&.black{
    .language-dropdown{
        .p-dropdown-trigger{
            color: #000000;
        }
    }
}
&.white{
    .language-dropdown{
        .p-dropdown-trigger{
            color: white;
        }
    }
}
.lang-container {
    position: relative;
    width: 2.2rem;
    flex-shrink: 0;
    height: 1.5rem;
    img{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}
.language-dropdown{
    background: none;
    border: none;
    width: 100%;
    .p-dropdown-label.p-inputtext{
        display: none;
    }
    .p-dropdown-trigger{
        padding: 0;
        margin:0;
        width: 100%;
        width: 100%;
        z-index: 2;
        span{
            font-size: 12px;
        }
    }
}

.desktop{
    &.language-dropdown.en{
        .p-dropdown-trigger{
            justify-content: flex-end;
        }
    }
    &.language-dropdown.ar{
        .p-dropdown-trigger{
            justify-content: flex-start;
        }
    }
}
.mobile{
    &.p-dropdown-trigger{
        justify-content: flex-end;
    }
}

.login.language-dropdown.en{
    .p-dropdown-trigger{
        justify-content: flex-end !important;
    }
}
.login.language-dropdown.ar{
    .p-dropdown-trigger{
        justify-content: flex-start !important;
    }
}

`

export default HeaderWrapper;